import React from 'react';
import { Box, CheckIcon, ChevronDownIcon, ChevronUpIcon, RawButton, RoundBlockIcon, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

import { IPermissionGroup } from '@/modules/role/role.types';

interface Props extends IPermissionGroup {
  collapsed: boolean;
  isGranted: boolean;
  isCopyMode?: boolean;
  onChangeCollapsed: (id: string) => void;
}
interface WrapperProps {
  isGranted?: boolean;
}
const Wrapper = styled(Box)<WrapperProps>`
  &:hover {
    background-color: ${({ theme, isGranted}) => isGranted ? theme.colors.successContainer : theme.colors.dangerContainer}
  }

`;
const PermissionGroup: React.FC<Props> = ({
  isCopyMode,
  isGranted, id, name,
  options, onChangeCollapsed,
  collapsed }) => {
  return (
    <Box direction="column" margin={{bottom: 'm'}}  border={isCopyMode ? undefined :{ side: 'top', size: 'small', color: 'border2' }}>
      <Box direction="row" margin={{ vertical: '6px' }}>
        <RawButton data-testid={`permissions-group_title_${id}`} onClick={() => onChangeCollapsed(id)}>
          <Box direction="row" align="center">
            {collapsed ? <ChevronDownIcon color="iconPrimary" /> : <ChevronUpIcon color="iconPrimary" />}

            <Text size="xxlarge" weight={400}>
              {name}
            </Text>
          </Box>
        </RawButton>
      </Box>
      {collapsed ? null : (
        <>
          {options.map((option) => (
            <Wrapper
              isGranted={isGranted}
              data-testid={`permissions-group_${id}_${option.id}`}
              align='center'
              round="container2Round"
              justify="between"
              pad={{ vertical: 'xxs', horizontal: 's' }}
              key={option.id}
              direction="row">
              <Box justify="center" direction="column" height={{ min: '40px' }}>
                <Text size="medium" weight={700} style={{ lineHeight: '20px' }}>
                  {option.name}
                </Text>
                {option.description && (
                  <Text size="small" weight={500} style={{ lineHeight: '20px' }} color="textSecondary">
                    {option.description}
                  </Text>
                )}
              </Box>
              {isGranted ? 
                <CheckIcon data-testid={`permissions-group_${id}_check-icon`} size="16px" color="success" />:
                <RoundBlockIcon data-testid={`permissions-group_${id}_block-icon`}  size="16px" color="danger"/>}

            </Wrapper>
          ))}
        </>
      )}
    </Box>
  );
};

export default PermissionGroup;
